import { DOMSerializer, DOMParser as PMDomParser } from '@tiptap/pm/model';

/**
 * Parses the HTML string to a ProseMirror document.
 * @param {string} html - The HTML string.
 * @param {Schema} schema - The ProseMirror schema.
 * @returns {Node} - The ProseMirror document.
 */
export const parseHTMLToDoc = (html, schema) => {
    const dom = new DOMParser().parseFromString(html, 'text/html');

    return PMDomParser.fromSchema(schema).parse(dom);
};

/**
 * Converts a ProseMirror document to an HTML string.
 * @param {Node} doc - The ProseMirror document.
 * @param {Schema} schema - The ProseMirror schema.
 */
export const convertDocToHTML = (doc, schema) => {
    const fragment = DOMSerializer.fromSchema(schema).serializeFragment(doc.content);
    const temporaryDiv = document.createElement('div');

    temporaryDiv.appendChild(fragment);

    return temporaryDiv.innerHTML;
};

/**
 * Manages a prefix for the given content based on the action specified.
 *
 * @param {boolean} isAddAction - Determines the action to perform. Default value: true.
 *                                If true, the prefix will be added to the content,
 *                                and will be removed if present for the isAddAction=false.
 * @param {string} content - The content to which the prefix is added or removed. Default value: ''.
 * @param {string} prefixName - The prefix to be managed. Default value: '__'.
 * @returns {string} - The modified content after adding or removing the prefix.
 */
export const manageDataPrefixToContent = (isAddAction = true, content = '', prefixName = '__') => {
    if (isAddAction) {
        return `${prefixName}${content}`;
    }

    if (content.startsWith(prefixName)) {
        return content.substring(prefixName.length);
    }

    return content;
};
